<cb-authorized>
    <cb-body>
        <cb-page-header>
            Documents
        </cb-page-header>
    </cb-body>
</cb-authorized>
